import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Tr3MaterialSharedAllModule } from './tr3-material-shared-all.module';

const sharedModules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  Tr3MaterialSharedAllModule,
];

@NgModule({
  imports: sharedModules,
  exports: sharedModules,
})
export class Tr3MaterialSharedExtModule {}
